{
  "id": "stepStool",
  "name": "Step Stool",
  "builds": "product",
  "category": "rustic",
  "note": "It takes a boot every day — every joint gets a screw.",
  "skill": "rusticProjects",
  "duration": 30,
  "offeredBy": "drill",
  "fastener": "screws",
  "value": 14,
  "widthIn": 24,
  "heightIn": 24,
  "slots": [
    {
      "id": "side-0",
      "role": "side",
      "part": {
        "widthIn": 6,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "thickness": [6, 8]
      },
      "xIn": 2,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0,
      "onEdge": true
    },
    {
      "id": "side-1",
      "role": "side",
      "part": {
        "widthIn": 6,
        "lengthIn": 24,
        "thicknessQ": 6
      },
      "stock": {
        "type": "board",
        "thickness": [6, 8]
      },
      "xIn": 22,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0,
      "onEdge": true
    },
    {
      "id": "tread-0",
      "role": "tread",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board"
      },
      "xIn": 12,
      "yIn": 4,
      "angleDeg": 90,
      "zIn": 6
    },
    {
      "id": "tread-1",
      "role": "tread",
      "part": {
        "widthIn": 4,
        "lengthIn": 24,
        "thicknessQ": 2
      },
      "stock": {
        "type": "board"
      },
      "xIn": 12,
      "yIn": 14,
      "angleDeg": 90,
      "zIn": 6
    }
  ],
  "fasteners": [
    {
      "xIn": 2,
      "yIn": 4
    },
    {
      "xIn": 2,
      "yIn": 14
    },
    {
      "xIn": 22,
      "yIn": 4
    },
    {
      "xIn": 22,
      "yIn": 14
    }
  ]
}
